import { isEmpty } from 'lodash';
import qs from 'qs';

import {
    buildDataForQueryString,
    buildFilterPayload,
} from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.utils';

export const notInSpecificPage = (location: string, pageName: string) => {
    return location.includes(`/${pageName}`);
};

export const getInitialFilterObj = ({
    projectId,
    contractId,
    versionId,
}: {
    projectId: number;
    contractId: number;
    versionId: number;
}) => {
    return {
        project: projectId,
        contract: contractId,
        version: versionId,
        cardActivity: [
            {
                id: 1,
                value: 'TASK_DEPENDENT',
                label: 'Task',
            },
            {
                id: 2,
                value: 'START_MILESTONE',
                label: 'Milestone',
            },
        ],
        flags: {},
    };
};

export const getFilterPayloadAndUrlQueryString = (finalData) => {
    const filterPayload = buildFilterPayload(finalData);
    const querystring = qs.stringify(buildDataForQueryString(finalData), {
        arrayFormat: 'comma',
        skipNulls: true,
        encode: true,
    });

    return {
        filterPayload,
        querystring,
    };
};

interface QuickLinkFunc {
    projectId: number;
    contractId: number;
    versionId: number;
    filters: {};
}

export const addFilterAndGetNewFilter = ({ filters, projectId, contractId, versionId }: QuickLinkFunc) => {
    let filterObject = getInitialFilterObj({
        projectId,
        contractId,
        versionId,
    });

    if (!isEmpty(filters)) {
        filterObject = { ...filterObject, ...filters };
    }
    const { filterPayload, querystring } = getFilterPayloadAndUrlQueryString(filterObject);
    return { filterPayload, querystring };
};
